import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/apiClient";
const usuariosRestringidos = ["cdconcepcion", "cdita", "cdcaazapa", "cdcde", "cditapua"];

const usuariosPermitidos = ["cgomez"];

const Navbar = ({ handleLogout }) => {
    const [username, setUsername] = useState("");
    const [companyDb, setCompanyDb] = useState("");
    const [databases, setDatabases] = useState([]);
    const [switchingDb, setSwitchingDb] = useState(false);
    const [switchDbError, setSwitchDbError] = useState("");

    const user = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem("sapUser") || "null");
        } catch {
            return null;
        }
    }, []);

    useEffect(() => {
        setUsername(user?.UserName || "");
        setCompanyDb(user?.CompanyDB || "");
    }, []); // Se ejecuta al montar el componente

    useEffect(() => {
        let alive = true;
        const load = async () => {
            try {
                const response = await apiClient.get("/databases");
                if (!alive) return;
                setDatabases(Array.isArray(response.data) ? response.data : []);
            } catch {
                // No bloqueamos el navbar si falla.
                if (!alive) return;
                setDatabases([]);
            }
        };
        load();
        return () => {
            alive = false;
        };
    }, []);

    const onChangeCompanyDb = async (e) => {
        const nextDb = e.target.value;
        setSwitchDbError("");

        if (!nextDb || nextDb === companyDb) {
            setCompanyDb(nextDb);
            return;
        }

        // Re-login “por debajo” para obtener nuevo token/sesión.
        try {
            setSwitchingDb(true);

            const currentUser = (() => {
                try {
                    return JSON.parse(localStorage.getItem("sapUser") || "null");
                } catch {
                    return null;
                }
            })();

            const username2 = currentUser?.UserName;
            const password2 = currentUser?.Password;
            if (!username2 || !password2) {
                throw new Error("No se encontraron credenciales guardadas. Volvé a iniciar sesión.");
            }

            const credentials = {
                username: username2,
                password: password2,
                database: nextDb,
            };

            const response = await apiClient.post("/login", credentials);
            if (!response?.data?.token) {
                throw new Error("No se pudo obtener una nueva sesión.");
            }

            const expiration = new Date();
            expiration.setMinutes(expiration.getMinutes() + 25);

            localStorage.setItem("sapToken", response.data.token);
            localStorage.setItem(
                "sapUser",
                JSON.stringify({
                    UserName: username2,
                    Password: password2,
                    CompanyDB: nextDb,
                    WhsCode: response.data.almacen,
                    ExpiresAt: expiration.toISOString(),
                })
            );

            setCompanyDb(nextDb);

            // Recargar para que toda la app use la nueva sesión.
            window.location.reload();
        } catch (err) {
            setSwitchDbError(err?.response?.data?.error || err?.message || "Error cambiando sociedad");
            // Revertimos el select al valor actual.
            setCompanyDb(user?.CompanyDB || "");
        } finally {
            setSwitchingDb(false);
        }
    };

    return (
        <>
            {switchingDb && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.35)",
                        zIndex: 2000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 16,
                    }}
                >
                    <div
                        className="bg-white rounded shadow p-4 text-center"
                        style={{ width: "min(420px, 92vw)" }}
                    >
                        <div className="spinner-border text-primary" role="status" aria-label="Cargando" />
                        <div className="mt-3 fw-semibold">Cambiando sociedad...</div>
                        <div className="text-muted small">Estamos renovando la sesión. Por favor esperá.</div>
                    </div>
                </div>
            )}

            <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
                <div className="container">
                <Link className="navbar-brand" to="/">
                    SAP Localización
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <Link className="nav-link" to="/dashboard">
                                Dashboard
                            </Link>
                        </li>
                        
                        {/* Socios de Negocios */}
                        {(!usuariosRestringidos.includes(username))&&(
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="clientsDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Socio de Negocios
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="clientsDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/clientes/nuevo">
                                        Nuevo Cliente
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/proveedores/nuevo">
                                        Nuevo Proveedor
                                    </Link>
                                </li>
                            </ul>
                        </li> )}
                        {/* Ventas */}
                        {(!usuariosRestringidos.includes(username))&&(
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="ventasDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Ventas
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="ventasDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/ventas/cancelacion-documentos">
                                        Cancelación de Documentos
                                    </Link>
                                </li>
                            </ul>
                        </li> )}
                        {/* Bancos */}
                        {(username === "EArguello" || username === "manager")&& (
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="bancosDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Bancos
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="bancosDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/bancos/pagos/sudameris">
                                        Sudameris
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/bancos/pagos/atlas">
                                        Atlas
                                    </Link>
                                </li>
                            </ul>
                        </li> )}

                        {/* Gestión Inmobiliaria */}
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="inmobiliariaDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Gestión Inmobiliaria
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="inmobiliariaDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/inmobiliaria/cotizaciones">
                                        Cotizaciones
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inmobiliaria/contratos">
                                        Contratos
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inmobiliaria/cobros">
                                        Registrar cobro
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/inmobiliaria/configuracion">
                                        Configuración
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        {/* Recordatorios */}
                        <li className="nav-item dropdown">
                            <button
                                className="nav-link dropdown-toggle btn btn-link"
                                id="recordatoriosDropdown"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                style={{ textDecoration: 'none' }}
                            >
                                Recordatorios
                            </button>
                            <ul className="dropdown-menu" aria-labelledby="recordatoriosDropdown">
                                <li>
                                    <Link className="dropdown-item" to="/recordatorios/control">
                                        Panel de control
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/recordatorios/clientes">
                                        Destinatarios
                                    </Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/recordatorios/configuracion">
                                        Configuración
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        {/* Tipo de cambio del día (global) */}
                        <li className="nav-item">
                            <Link className="nav-link text-nowrap" to="/tipo-cambio">
                                Tipo de cambio
                            </Link>
                        </li>

                    </ul>

                    {/* Selector de sociedad (CompanyDB) */}
                    <div className="d-flex align-items-center ms-auto me-2">
                        <select
                            className="form-select form-select-sm"
                            style={{ minWidth: 220 }}
                            value={companyDb || ""}
                            onChange={onChangeCompanyDb}
                            disabled={switchingDb || databases.length === 0}
                            title={companyDb || "Sociedad"}
                        >
                            {databases.length === 0 && <option value="">Sociedad</option>}
                            {databases.map((db, idx) => (
                                <option key={idx} value={db.CompanyDB}>
                                    {db.CompanyName || db.CompanyDB}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Botón de cerrar sesión alineado a la derecha */}
                    <button
                        className="btn btn-danger ms-auto"
                        onClick={handleLogout}
                        disabled={switchingDb}
                    >
                        Cerrar Sesión
                    </button>
                </div>
            </div>
            </nav>

            {switchDbError && (
                <div
                    className="position-fixed"
                    style={{ right: 16, bottom: 16, zIndex: 2100, width: "min(520px, 92vw)" }}
                >
                    <div className="alert alert-danger shadow mb-0" role="alert">
                        {switchDbError}
                    </div>
                </div>
            )}
        </>
    );
};

export default Navbar;
